var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
// css
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/redeemDetail.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Aif&PmsSidebar.scss";
// components
import { ClientDetails, InputComponent, } from "@frameworks/pmsjourney/components";
import FolioSelector from "@frameworks/pmsjourney/components/FolioSelector";
import AccordionComponent from "@frameworks/pmsjourney/components/AccordionComponent";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import RedeemDetails from "@frameworks/pmsjourney/components/RedeemComponent/RedeemDetail";
import { ToastModal } from "@frameworks/pmsjourney/components/common";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
// helpers
import { addCommasWithConditionalDecimal } from "@domains/utils/numberMethods";
import debounce from "@frameworks/web/utils/debounce";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { ONE_THOUSAND_CRORE_RUPEE } from "@frameworks/pmsjourney/constants";
import { changeInRupeeFormat } from "@frameworks/pmsjourney/utils";
import FileUploadComponent from "./components/FileUpload";
import Loader from "@frameworks/shared-library/components/Loader";
var RedeemEditBody = function (_a) {
    //
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var loading = _a.loading;
    var _m = __read(useState(false), 2), isDisabled = _m[0], setDisabled = _m[1];
    var _o = __read(useState(false), 2), visible = _o[0], setVisible = _o[1];
    var _p = __read(useState(""), 2), message = _p[0], setMessage = _p[1];
    var _q = __read(useState(false), 2), redeemAll = _q[0], setRedeemAll = _q[1];
    var _r = __read(useState(true), 2), isValid = _r[0], setIsValid = _r[1];
    var _s = useSelector(function (state) { return state.markets.qualityCheck; }), pendingTransactionById = _s.pendingTransactionById, folioDetails = _s.folioDetails;
    var _t = useSelector(function (state) { return state.markets.AifPms; }), subCategoryId = _t.subCategoryId, watchListData = _t.watchListData, clientDetails = _t.clientDetails;
    var redeem = useSelector(function (state) { return state.markets.payment; }).redeem;
    useEffect(function () {
        var _a, _b;
        if (((_a = folioDetails === null || folioDetails === void 0 ? void 0 : folioDetails.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var item = (_b = folioDetails === null || folioDetails === void 0 ? void 0 : folioDetails.data) === null || _b === void 0 ? void 0 : _b[0];
            if (item) {
                if (Number(ESubProductIds.AIF) === Number(subCategoryId)) {
                    setRedeemAll(true);
                    setDisabled(true);
                }
                else {
                    setRedeemAll(false);
                    setDisabled(false);
                }
                aifPmsDi.payment.updateRedeemValues(__assign(__assign({}, redeem), { redeemAmount: String(item.marketValue), approxUnit: item.totalQty, folio: item.folioNo, totalqty: item.totalQty, marketvalue: Number(item.marketValue) }));
            }
        }
    }, [folioDetails]);
    useEffect(function () {
        var _a, _b;
        if (((_a = folioDetails === null || folioDetails === void 0 ? void 0 : folioDetails.data) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            redeem.folio == "" &&
            subCategoryId == Number(ESubProductIds.PMS)) {
            var item = (_b = folioDetails === null || folioDetails === void 0 ? void 0 : folioDetails.data) === null || _b === void 0 ? void 0 : _b[0];
            handleSelectFolio({
                units: item.totalQty,
                number: item.folioNo,
                amount: String(item.marketValue),
            });
        }
    }, [folioDetails]);
    var handleSelectFolio = useCallback(function (folio) {
        var updatedValues = __assign(__assign({}, redeem), { folio: folio.number, totalqty: folio.units, marketvalue: Number(folio.amount) });
        aifPmsDi.payment.updateRedeemValues(updatedValues);
    }, []);
    var debouncedFetchApproxUnit = useCallback(debounce(function (value) {
        var _a, _b;
        var amount = Number(((_a = redeem === null || redeem === void 0 ? void 0 : redeem.redeemAmount) === null || _a === void 0 ? void 0 : _a.split(",").join("")) || value);
        if ((redeem === null || redeem === void 0 ? void 0 : redeem.folio) && amount > 0) {
            aifPmsDi.global
                .holdingQtyDetails({
                categorycode: subCategoryId,
                clientcode: clientDetails.uniqueCode,
                amount: Number(((_b = redeem === null || redeem === void 0 ? void 0 : redeem.redeemAmount) === null || _b === void 0 ? void 0 : _b.split(",").join("")) || value),
                schemeid: watchListData.schemeId,
                foliono: redeem === null || redeem === void 0 ? void 0 : redeem.folio,
            })
                .then(function (response) {
                var _a;
                setVisible(false);
                setMessage("");
                aifPmsDi.payment.updateRedeemValues(__assign(__assign({}, redeem), { approxUnit: (_a = response.data) === null || _a === void 0 ? void 0 : _a.qty }));
            })
                .catch(function (error) {
                setVisible(false);
                setMessage(error);
            });
        }
    }, 1000), [redeem, subCategoryId, clientDetails, watchListData]);
    var onChangeRedeem = function (event) {
        var value = event.target.value;
        var formatter = new Intl.NumberFormat("en-IN", {});
        var val = value.replace(/,/g, "");
        val = Number(val);
        var newVal = formatter.format(val);
        var isValid = Number(val) >= 1;
        setIsValid(isValid);
        if (val <= ONE_THOUSAND_CRORE_RUPEE) {
            aifPmsDi.payment.updateRedeemValues(__assign(__assign({}, redeem), { redeemAmount: newVal == "0" ? "" : newVal }));
        }
    };
    useEffect(function () {
        debouncedFetchApproxUnit();
    }, [redeem.redeemAmount]);
    var handleOnChangeRedeemReason = function (event) {
        aifPmsDi.payment.updateRedeemValues(__assign(__assign({}, redeem), { reason: event.target.value }));
    };
    var handleChangeCheckbox = function (checked) {
        var updatedValues = __assign(__assign({}, redeem), { termAccepted: checked });
        aifPmsDi.payment.updateRedeemValues(updatedValues);
    };
    var handleKeyPress = function (event) {
        var charCode = event.charCode || event.keyCode;
        if ((charCode >= 48 && charCode <= 57) || charCode === 44) {
            return true;
        }
        event.preventDefault();
    };
    var handleChangeCheckboxFolio = useCallback(function (event) {
        var _a;
        var checked = event.target.checked;
        setRedeemAll(checked);
        setIsValid(true);
        if (checked) {
            aifPmsDi.payment.updateRedeemValues(__assign(__assign({}, redeem), { redeemAmount: changeInRupeeFormat(String((_a = redeem.marketvalue) === null || _a === void 0 ? void 0 : _a.toFixed(2))), approxUnit: redeem.totalqty }));
            setDisabled(true);
        }
        else {
            setDisabled(false);
        }
    }, [changeInRupeeFormat, setDisabled, redeem]);
    var handleOnSelectFolio = useCallback(function (item) {
        aifPmsDi.payment.updateRedeemValues(__assign(__assign({}, redeem), { folio: item.number, totalqty: item.units, marketvalue: Number(item.amount) }));
    }, [redeem]);
    function getRedeemColor(subCategoryId) {
        var _a;
        var _b;
        var amt = (_b = redeem.redeemAmount) === null || _b === void 0 ? void 0 : _b.replace(/,/g, "");
        var thresholds = (_a = {},
            _a[ESubProductIds.AIF] = 10000000,
            _a[ESubProductIds.PMS] = 5000000,
            _a);
        var threshold = thresholds[subCategoryId];
        if (threshold === undefined) {
            return "Invalid subCategoryId";
        }
        return Number(amt) < threshold
            ? "txt-orange-light"
            : "txt-whispering-periwinkle";
    }
    return (React.createElement("div", { className: "bg_aqua_whites primary-order-book-mandate-sidebar-body order_book_details order-book-body-height" }, loading ? (React.createElement(Loader, null)) : (React.createElement("div", { className: "rounded width-375 position-relative" },
        React.createElement("div", { className: "bg-white px-3 py-4-custom rounded shadow" },
            React.createElement(ClientDetails, null),
            React.createElement(RedeemDetails, { item: {
                    //@ts-expect-error
                    data: {
                        amount: (_b = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data) === null || _b === void 0 ? void 0 : _b.amount,
                        holdingdate: (_c = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data) === null || _c === void 0 ? void 0 : _c.holdingDate,
                        units: (_d = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data) === null || _d === void 0 ? void 0 : _d.qty,
                        initialpurchasedate: (_e = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data) === null || _e === void 0 ? void 0 : _e.initialPurchaseDate,
                        rmName: (_f = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data) === null || _f === void 0 ? void 0 : _f.rmName,
                        rmCode: (_g = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data) === null || _g === void 0 ? void 0 : _g.rmCode,
                        redemptiontime: (_h = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data) === null || _h === void 0 ? void 0 : _h.redemptionTime,
                    },
                } }),
            React.createElement("form", { className: "p-top-20 form" },
                React.createElement("div", { className: "" },
                    React.createElement(FolioSelector, { folios: (_k = (folioDetails &&
                            (folioDetails === null || folioDetails === void 0 ? void 0 : folioDetails.data) &&
                            ((_j = folioDetails === null || folioDetails === void 0 ? void 0 : folioDetails.data) === null || _j === void 0 ? void 0 : _j.map(function (item) { return ({
                                units: item.totalQty,
                                number: item.folioNo,
                                amount: String(item.marketValue),
                            }); })))) !== null && _k !== void 0 ? _k : [], selectedFolio: redeem === null || redeem === void 0 ? void 0 : redeem.folio, onSelect: handleOnSelectFolio }),
                    (redeem === null || redeem === void 0 ? void 0 : redeem.folio) && (React.createElement("div", { className: "top-container rounded", style: { padding: 10, marginTop: 8 } },
                        React.createElement("div", { className: "top-list" },
                            React.createElement("div", { className: "top-left" },
                                React.createElement("p", { className: "top-title DMSans_13_400" }, "Available To Redeem"),
                                React.createElement("p", { className: "top-subtitle RobotoM_15_400 number-large" },
                                    "\u20B9",
                                    addCommasWithConditionalDecimal(redeem === null || redeem === void 0 ? void 0 : redeem.marketvalue))),
                            React.createElement("div", { className: "top-right" },
                                React.createElement("p", { className: "top-title DMSans_13_400" }, "Units"),
                                React.createElement("p", { className: "top-subtitle RobotoM_15_400 number-large" }, redeem.totalqty)))))),
                React.createElement(InputComponent, { autoComplete: "off", label: "Redeem Amount (₹)", placeholder: "Enter amount here", helperText: "", name: "redeem", minAmount: 1, max: redeem.marketvalue, value: redeem === null || redeem === void 0 ? void 0 : redeem.redeemAmount, required: true, isInvalid: !isValid, approx: true, approxUnit: redeem.approxUnit, onChangeEvent: onChangeRedeem, onKeyPress: handleKeyPress, disabled: isDisabled, redeemHelperText: React.createElement("div", { className: "d-flex mt-2 justify-content-between" },
                        React.createElement("span", { className: "".concat(getRedeemColor(String(subCategoryId)), " DMSansNormal_12_400 ") }, ESubProductIds.AIF === String(subCategoryId)
                            ? "Minimum holding of ₹ 1 Crore is preferred"
                            : "Minimum holding of ₹ 50 Lakhs is preferred"),
                        React.createElement(GenericCheckbox, { customLabel: "Redeem All", checkboxType: "han-blue", checkboxProps: {
                                onChange: handleChangeCheckboxFolio,
                                checked: redeemAll,
                            } })) }),
                React.createElement("div", { className: "ai-container ai-input" },
                    React.createElement("div", { className: "d-flex align-items-center" },
                        React.createElement("label", { className: "ai-label DMSanN_14_400" }, "Redeem Reason")),
                    React.createElement("textarea", { placeholder: "Enter reason here", className: "ai-container ai-input RobotoR_14_400 bg-transparent", maxLength: 500, value: redeem === null || redeem === void 0 ? void 0 : redeem.reason, onChange: handleOnChangeRedeemReason }),
                    React.createElement("div", { className: "ai-min-text DMSansNormal_12_400 text-right" }, (_l = redeem === null || redeem === void 0 ? void 0 : redeem.reason) === null || _l === void 0 ? void 0 :
                        _l.length,
                        "/500")))),
        React.createElement("div", { className: "d-flex flex-column gap-3" },
            React.createElement(AccordionComponent, { items: [
                    {
                        header: "Upload Form",
                        body: React.createElement(FileUploadComponent, { fileSize: 5 }),
                        optional: false,
                        leftIcon: "edel-icon-medal-bookmark",
                    },
                ] }),
            React.createElement(GenericCheckbox, { customLabel: "I acknowledge that exit load charges may apply if units are redeemed within the specified period.", checkboxType: "han-blue", parentClassName: "checkbox-wrap redeem_acknowledge_checkbox", checkboxProps: {
                    checked: redeem.termAccepted,
                    onChange: function () { return handleChangeCheckbox(!redeem.termAccepted); },
                } })),
        React.createElement(ToastModal, { visible: visible, setVisible: setVisible, message: message })))));
};
export default RedeemEditBody;
